import type { ReactNode } from "react";

type IconComponent = (props: {
  size?: number | string;
  className?: string;
}) => any;

export function RfqSection({
  icon: Icon,
  title,
  action,
  children,
  className = "",
  bodyClassName = "p-6",
}: {
  icon: IconComponent;
  title: string;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
}) {
  return (
    <section
      className={`overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm ${className}`}
    >
      <div className="flex flex-wrap items-center justify-between gap-3 border-b border-gray-200 bg-gray-50 px-6 py-4">
        <div className="flex items-center gap-2">
          <Icon size={16} className="text-blue-600" />
          <h3 className="text-sm font-medium text-gray-700">{title}</h3>
        </div>
        {action}
      </div>
      <div className={bodyClassName}>{children}</div>
    </section>
  );
}

export function RfqField({
  icon: Icon,
  label,
  value,
}: {
  icon?: IconComponent;
  label: string;
  value?: ReactNode;
}) {
  return (
    <div className="space-y-1.5">
      <label className="flex items-center gap-1.5 text-xs text-gray-500">
        {Icon ? <Icon size={13} /> : null}
        {label}
      </label>
      <div className="flex min-h-9 items-center rounded-md border border-gray-200 bg-gray-50 px-3 py-1.5 text-sm text-gray-700">
        {value || value === 0 ? (
          value
        ) : (
          <span className="text-gray-400">—</span>
        )}
      </div>
    </div>
  );
}
